import { computed, ref } from 'vue'
import { FindShopHomePageSummary } from '@/api/shopHomePageSummary'
import { useFetch } from '@/use/fetch'
import { useShop } from '@/use/shop'

/**
 * 使用期間顯示文字；後端回傳 YYYY-MM-DD，直接換成 YYYY/MM/DD 避免時區換算跨日
 * @param {string | null} start 起日
 * @param {string | null} end 迄日
 * @returns {string}
 */
export const formatUsagePeriod = (start, end) => {
  if (!start && !end) return '-'
  const format = (date) => (date ? date.replace(/-/g, '/') : '-')
  return `${format(start)}～${format(end)}`
}

/**
 * 店家首頁統計：使用期間、預約次數、行前推薦次數、個人績效與業績優化查詢次數（CNCY-10767）
 */
export const useShopHomePageSummary = () => {
  const { simpleFetch } = useFetch()
  const { shopId } = useShop()
  const summary = ref(null)
  const loading = ref(false)

  const displayCount = (key) => {
    const value = summary.value && summary.value[key]
    return typeof value === 'number' ? value : '-'
  }

  const summaryItems = computed(() => [
    {
      key: 'usagePeriod',
      value: summary.value ? formatUsagePeriod(summary.value.usagePeriodStart, summary.value.usagePeriodEnd) : '-',
    },
    { key: 'reservationCount', value: displayCount('reservationCount') },
    { key: 'preVisitRecommendationCount', value: displayCount('preVisitRecommendationCount') },
    { key: 'appointmentUnitPerformanceViewCount', value: displayCount('appointmentUnitPerformanceViewCount') },
  ])

  const getSummary = async () => {
    if (!shopId.value) return
    loading.value = true
    await simpleFetch(FindShopHomePageSummary, { shopId: shopId.value }, (res) => {
      summary.value = res
    })
    loading.value = false
  }

  return { summary, summaryItems, loading, getSummary }
}
